import { render, staticRenderFns } from "./AskAi.vue?vue&type=template&id=4374661f&"
import script from "./AskAi.vue?vue&type=script&lang=js&"
export * from "./AskAi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports